const state = {
  runtime:null,
  "configIsLoaded":false
};
const getters = {
};
const mutations = {
  setConfig: (state, payload) => {
    state.runtime = payload;
    state.configIsLoaded = true;
  },
};
const actions = {
  async fetchConfig({ commit }) {
    try {
      const response = await fetch("./config/runtime.json");
      const configJson = await response.json();
      commit("setConfig", configJson);
    } catch (error) {
      console.error("Error fetching config:", error);
    }
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};
